__turbopack_context__.v({
  "axis": "website-analytics-demo-module__9dgLJa__axis",
  "chart": "website-analytics-demo-module__9dgLJa__chart",
  "content": "website-analytics-demo-module__9dgLJa__content",
  "funnel": "website-analytics-demo-module__9dgLJa__funnel",
  "grow": "website-analytics-demo-module__9dgLJa__grow",
  "integration": "website-analytics-demo-module__9dgLJa__integration",
  "log": "website-analytics-demo-module__9dgLJa__log",
  "metrics": "website-analytics-demo-module__9dgLJa__metrics",
  "panel": "website-analytics-demo-module__9dgLJa__panel",
  "tabs": "website-analytics-demo-module__9dgLJa__tabs",
});
